import React, { Fragment, useState, useCallback } from 'react';
import { List, ListSubheader, Icon, Button } from '@mui/material';
import ScoreIcon from 'global/components/ScoreIcon';
import ChecklistScores from '../ChecklistScores';
import { SystemBlock, SystemHeader, HeaderChild, HeaderChildScore, HeaderChildName, HeaderCriteria, ToggleSidebar, ShowImages } from './styles';
import { get, last } from 'global/lib/lodash';
import { getItemKey, getId } from './utils';
import { ImageSelectBtn } from '../Assessment/utils';

export function SystemScore(props) {
  const { pssvSystem, setSidebarOpen, activeEdit, pssvChecklist, selectItem, selectedItems, showSelectBoxes, isCourse, notFirst, printView, hideSystemHeader, bordered, itemPasses } = props;
  const pChildren = get(pssvSystem, 'children', []).filter((f) => (activeEdit ? getId(pssvChecklist) === getId(f) : true));
  const isSelected = useCallback((item) => get(selectedItems, getItemKey(item)), [selectedItems]);
  const hasSelectedItems = Object.keys(selectedItems).filter((k) => get(selectedItems, [k, 'itemType']) === 'checkpoint').length > 0;

  const currentSelect = isSelected(pssvSystem);
  const indeterminate = Object.keys(selectedItems).filter((k) => get(selectedItems, [k, 'parentId']) == pssvSystem?.id).length > 0;

  const useCompareScore = get(props, 'filter.assessment_status') !== 'active';
  const useCompare = useCompareScore && get(props, 'filter.useDiff');

  const ScoreIconProps = {
    ...(!activeEdit
      ? {
          scorecard: props.scorecard,
          useBlankCheckbox: printView ? false : showSelectBoxes,
          selected: !printView && showSelectBoxes && get(currentSelect, 'fullCount'),
          indeterminate: !printView && showSelectBoxes && indeterminate,
          onClick: printView ? undefined : () => selectItem(pssvSystem),
          useCompare,
          compare: get(pssvSystem, 'compare', null),
          displayValue: get(pssvSystem, 'displayValue', null),
          canClick: false,
          filter: get(props, 'filter'),
        }
      : {}),

    score: useCompareScore && !useCompare ? get(pssvSystem, 'compare.value') : get(pssvSystem, 'value'),
    active: useCompareScore && !useCompare ? get(pssvSystem, 'compare') : pssvSystem,
  };

  const RootWrap = notFirst ? SystemBlock : 'div';

  return (
    <RootWrap key={getId(pssvSystem)}>
      {!isCourse && !hideSystemHeader && (
        <SystemHeader as={ListSubheader} disableGutters={true}>
          <ScoreIcon bordered={bordered} actionable={itemPasses?.(pssvSystem)} {...ScoreIconProps} />
          <HeaderChild as="h2">
            <HeaderChildName>{get(pssvSystem, 'name')}</HeaderChildName>
            {get(pssvSystem, 'criteria') && <HeaderCriteria className="weight-criteria">{get(pssvSystem, 'criteria')}</HeaderCriteria>}
          </HeaderChild>
          {!useCompare && <HeaderChildScore as="h2">{get(ScoreIconProps, 'active.displayValue')}</HeaderChildScore>}
          <div style={{ flexGrow: 1 }}></div>
          {!printView && (
            <ToggleSidebar as={Button} onClick={() => setSidebarOpen(true)}>
              <Icon>view_list</Icon>
            </ToggleSidebar>
          )}

          {!printView && (
            <ShowImages
              as={ImageSelectBtn}
              variant="text"
              color="secondary"
              tooltip={`${get(pssvSystem, 'name')} Photos`}
              superset_id={get(pssvSystem, 'supersetId')}
              assessment={get(props, 'assessment.data')}
              scores={get(props, 'allScoreData', [])}
              canSelect={false}
            />
          )}
        </SystemHeader>
      )}
      <List>
        {pChildren.map((data, i) => (
          <Fragment key={data.id}>
            <ChecklistScores
              {...props}
              pssvChecklist={data}
              isSelected={isSelected}
              hasSelectedItems={hasSelectedItems}
              next={(activeEdit && props.next) || get(pChildren, i + 1, get(props, 'next.children.0'))}
              prev={(activeEdit && props.prev) || get(pChildren, i - 1, last(get(props, 'prev.children')))}
              hideSystemHeader={hideSystemHeader}
            />
          </Fragment>
        ))}
      </List>
    </RootWrap>
  );
}
